import axios from 'axios';
import { isCanceledError } from '@/utils/helpers';

export const sparkApi = axios.create({
  baseURL: import.meta.env.VITE_SPARK_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true, // Send cookies with cross-origin requests
});

sparkApi.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (import.meta.env.DEV && !isCanceledError(error)) {
      console.error('Spark API Error:', error);
    }

    return Promise.reject(error);
  }
);
